import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { LeatherBitcoinInjectedProvider } from '../LeatherBitcoinInjectedProvider.types';

const LEATHER_BITCOIN_PROVIDER_LOCATOR = 'LeatherProvider';

export const getLeatherBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<LeatherBitcoinInjectedProvider>(
    LEATHER_BITCOIN_PROVIDER_LOCATOR
  );
};
